export class ChunkCache {
    _sequenceNumber;
    _byteLength = 0;
    cache = [];
    constructor(sequenceNumber) {
        this._sequenceNumber = sequenceNumber;
    }
    get sequenceNumber() {
        return this._sequenceNumber;
    }
    get byteLength() {
        return this._byteLength;
    }
    get chunks() {
        return this.cache.filter((chunk) => chunk !== null);
    }
    transfer(cache) {
        cache = cache.filter((chunk) => chunk !== null);
        const count = cache.length;
        for (const chunk of cache) {
            this.append(chunk);
        }
        return count;
    }
    append(chunk) {
        this._sequenceNumber.increment();
        if (chunk !== null) {
            this._byteLength += chunk.byteLength;
        }
        this.cache.push(chunk);
    }
    prune(theirSequenceNumber) {
        try {
            this._sequenceNumber.validate(theirSequenceNumber);
        }
        catch (error) {
            throw new Error(`Remote sent us an invalid sequence number: ${theirSequenceNumber}`);
        }
        const beginOffset = theirSequenceNumber - this._sequenceNumber.get();
        if (beginOffset > 0) {
            throw new Error('Remote travelled through time and acknowledged a chunk which is in the future');
        }
        else if (-beginOffset > this.cache.length) {
            throw new Error('Remote travelled back in time and acknowledged a chunk it has already acknowledged');
        }
        const chunkCountBefore = this.cache.length;
        this.cache = beginOffset === 0 ? [] : this.cache.slice(beginOffset);
        this._byteLength = this.cache
            .filter((chunk) => chunk !== null)
            .reduce((sum, chunk) => sum + chunk.byteLength, 0);
        return {
            acknowledged: chunkCountBefore + beginOffset,
            left: this.cache.length,
        };
    }
}
